import { Address } from 'viem'

export interface APIFarmToken {
  id: string
  symbol: string
  name: string
  decimals: number
  price: number
  totalSupply: number
  priceStrategy: string
  lastIndexed: Record<string, any>
}

export interface APIVault {
  id: string
  provider: string
  lowerTick: number | null
  upperTick: number | null
  currentTick: number | null
  tvl: number
  farmTvl: number
  apr: number
  weeklyFeesEarnedUSD: number
  feeTier: number | null
  totalApr: number
  lastUpdated: Record<string, any>
  isSweetened: boolean
  isRewardVault: boolean
  isVolatile: boolean
  lastIndexed: Record<string, any>
  totalSupply: number
  managerTreasury: string | null
  manager: string | null
  createdAtTimestamp: string
  isWhiteListed: boolean
  token0: APIFarmToken
  token1: APIFarmToken
}

export interface APIFarm {
  id: Address
  address: Address
  provider: string
  tvl: number
  apr: number
  rewardRates: string[]
  stakingToken: APIFarmToken
  isPaused: boolean
  isActive: boolean
  stakingPaused: boolean
  stakesUnlocked: boolean
  withdrawalsPaused: boolean
  rewardsCollectionPaused: boolean
  rewardsDuration: string
  lockTimeMin: string
  lockTimeMax: string
  lockMaxMultiplier: string
  totalLiquidityLocked: string
  vault: APIVault | null
  rewardTokens: APIFarmToken[]
}

export interface APIFarmsResponse {
  data: APIFarm[]
  count: number
}

export interface KodiakFarm {
  id: Address
  address: Address
  provider: string
  tvl: number
  apr: number
  rewardRates: string[]
  stakingToken: APIFarmToken
  isPaused: boolean
  isActive: boolean
  stakingPaused: boolean
  stakesUnlocked: boolean
  stakingTokenType: StakingTokenType
  withdrawalsPaused: boolean
  rewardsCollectionPaused: boolean
  rewardsDuration: string
  lockTimeMin: string
  lockTimeMax: string
  lockMaxMultiplier: string
  totalLiquidityLocked: string
  vault: APIVault | null
  rewardTokens: APIFarmToken[]
  rewardTokensWithRates: {
    id: Address
    address: Address
    rewardRate: string
    symbol: string
    name: string
    decimals: number
  }[]
}

export enum StakingTokenType {
  ISLAND = 'island', // vault.provider === 'kodiak'
  V2 = 'v2', // vault.provider === 'v2'
  CHARM = 'charm', // vault.provider === 'charm'
  GENERIC = 'generic', // vault === null
}
